export const hidePlayerIframeToScreenReaders = () =>
    document
        .querySelector('iframe[id^=ya-video-player-frame]')
        ?.setAttribute('aria-hidden', 'true');
